module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCondIt.0e5c216.woff";